import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchWorkspaceFeedback } from "api/services/workspace-service";
import { IUpdateTrainingFeedbackRequest } from "api/models/request/feedback/IUpdateTrainingFeedbackRequest";
import { WORKSPACE_FEEDBACK_QUERY_KEY } from "hooks/feedback/queryKeys";
import { useAuthContext } from "hooks/useAuthContext";

interface UpdateWorkspaceFeedbackRequest extends IUpdateTrainingFeedbackRequest {
    feedbackId: string;
}

export const useUpdateWorkspaceFeedback = () => {
    const queryClient = useQueryClient();
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const mutation = useMutation({
        mutationFn: async (request: UpdateWorkspaceFeedbackRequest): Promise<void> => {
            if (!workspaceId) {
                throw new Error("feedbackManagement.saveError");
            }

            const response = await patchWorkspaceFeedback({
                workspaceId,
                ...request,
            });

            if (!response?.success) {
                throw new Error(response?.message ?? "feedbackManagement.saveError");
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: WORKSPACE_FEEDBACK_QUERY_KEY });
        }
    });

    return {
        updateFeedback: mutation.mutateAsync,
        updatingFeedback: mutation.isPending,
    };
};
